import React, { useState } from "react";
import { ROUTES } from "./constants";
import InvoiceManagement from "./InvoiceManagement";

export default function Index() {
  const [page, setPage] = useState(ROUTES.DETAILS);

  switch (page) {
    case ROUTES.DETAILS:
      return <InvoiceManagement setPage={setPage} />;

    default:
      return <InvoiceManagement setPage={setPage} />;
  }
}
